export class StopNameFormatter {
  static formatStopNames(stops: string[]): string[] {
    return stops.map((stop: string) => {
      const label = stop.trim();
      const parts = label.split(',');
      const mainName = parts[0].trim();

      if (parts.length < 2) {
        return mainName;
      }

      const secondPart = parts[1].trim();
      let formattedLabel = mainName;

      if (secondPart.includes('Автостанція') || secondPart.includes('автостанція')) {
        const match = secondPart.match(/["']([^"']+)["']/);
        formattedLabel = match
          ? `${mainName} АС "${match[1]}"`
          : `${mainName} АС`;
      } else if (secondPart.includes('Автовокзал') || secondPart.includes('автовокзал')) {
        formattedLabel = `${mainName} АВ`;
      } else if (secondPart.includes('Зупинка') || secondPart.includes('зупинка')) {
        const match = secondPart.match(/["']([^"']+)["']/);
        formattedLabel = match
          ? `${mainName} (${match[1]})`
          : mainName;
      } else if (secondPart.includes('вокзал') || secondPart.includes('Вокзал')) {
        const match = secondPart.match(/["']([^"']+)["']/);
        formattedLabel = match
          ? `${mainName} ВК "${match[1]}"`
          : `${mainName} ВК`;
      }

      return formattedLabel;
    });
  }
}